/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/scope */
import { Empty, Tooltip } from "antd";
import { TranslateString } from "Utils/Common";
import moment from "moment";
import { CloseOutlined, CheckOutlined, EyeOutlined } from '@ant-design/icons';
import {useIntl} from 'react-intl';

const SingleLoanViewThree = ({ offerList, loanData, downloadBlobFile }: any) => {
    const intl=useIntl();
    const closed_tender_status = ["tendering_rejected", "invoiced", "tendering_declined", "done", "end_tender", "bond_sent_to_accounting", "signed_meeting_minutes_received"];
    return (
        <>
            <div className='mt-4 cu-table-border cu-text-small'>
                <table className="table table-sm table-bordered table-striped mb-0" >
                    <thead className="fw-bold">
                        <tr className='align-top'>
                            <td scope="col" className='cu-bg-green text-center cu-eight-width'>{TranslateString('tender_request_submitted')}</td>
                            <td scope="col" className='cu-bg-green text-left cu-seven-width'>{TranslateString('bank')}</td>
                            <td scope="col" className='cu-bg-green text-left cu-ten-width'>{TranslateString('sent_to_email')}</td>
                            <td scope="col" className='cu-bg-green text-left cu-seven-width'>{TranslateString('quotaion_deadline')}</td>
                            {/* <td scope="col" className='cu-bg-green text-left cu-seven-width'>{TranslateString('internal_quotaion_deadline')}</td> */}
                            <td scope="col" className='cu-bg-green text-left cu-eight-width'>{TranslateString('offer_received')}</td>
                            <td scope="col" className='cu-bg-green text-center cu-seven-width'>{TranslateString('offer_valid_until')}</td>
                            <td scope="col" className='cu-bg-green text-right cu-five-width'>{TranslateString('margin')}</td>
                            <td scope="col" className='cu-bg-green text-center cu-five-width'>{TranslateString('winner')}</td>
                            <td scope="col" className='cu-bg-green text-left'>{TranslateString('feedback')}</td>
                            <td scope="col" className='cu-bg-green text-center cu-ten-width'>{TranslateString('documents')}</td>
                        </tr>
                    </thead>
                    <tbody >
                        {offerList?.length > 0 ? offerList?.map((val: any) => {
                            return (
                                <tr>
                                    <td className="text-center">{val?.tender_req_updated_at || "-"}</td>
                                    <td className="text-left">{val?.BANK_DATA?.bank_name || "-"}</td>
                                    <td className="text-left">{val?.BANK_DATA?.bank_email || "-"}</td>
                                    <td className="text-left">{moment(val?.tender_req_deadline).format("DD.MM.YYYY") || "-"}</td>
                                    {/* <td className="text-left">{val?.tender_req_internal_deadline ? moment(val?.tender_req_internal_deadline).format("DD.MM.YYYY") : "-"}</td> */}
                                    <td className="text-left">{val?.offer_submit_at || "-"}</td>
                                    <td className="text-left">{val?.offer_valid_date ? (moment(val?.offer_valid_date).format("DD.MM.YYYY") || "-") : "-"}</td>
                                    <td className="text-right fw-bold">{val?.offer_margin || "-"}</td>
                                    <td className="text-center">
                                        {val?.is_tender_winner == "0" ? <CloseOutlined className="m-0 fs-5" /> : <CheckOutlined className="m-0 fs-5" />}
                                        {/* {closed_tender_status.includes(loanData?.loan_tender_status) ? val?.is_tender_winner == "0" ? <CloseOutlined className="m-0 fs-5" /> : <CheckOutlined className="m-0 fs-5" /> : "-"} */}
                                    </td>
                                    <td className="text-left">{closed_tender_status.includes(loanData?.loan_tender_status) && val?.feedback ? val?.feedback : "-"}</td>
                                    <td className="text-center" role='button'>
                                        <div className="d-flex justify-content-center">
                                            {val?.LOAN_DOC?.length ? val?.LOAN_DOC?.map((foo: any) => {
                                                return(
                                                    <>
                                                        <div>
                                                            <a className="cu-color-right" 
                                                            href='javascript:void(0)'
                                                            onClick={() => {
                                                                downloadBlobFile(foo?.loan_status_id)
                                                            }}
                                                             rel='noopener noreferrer'>
                                                                <Tooltip title={TranslateString('view')}>
                                                                    <EyeOutlined
                                                                        className="fs-5"
                                                                    />
                                                                </Tooltip>
                                                            </a>
                                                        </div>
                                                        <div>&nbsp;</div>
                                                    </>
                                                )
                                            }) : "-"}
                                        </div>
                                    </td>
                                </tr>
                            )
                        }) : <tr><td colSpan={9}><Empty description={intl.formatMessage({id: 'no_data'})}/></td></tr>}
                    </tbody>
                </table>
            </div>
        </>
    );
};
export default SingleLoanViewThree;